import { contentTypeForUploadName, MAX_FILESIZE } from "@nnr/global";
import {
  FileDto,
  fileControllerConfirmFileUpload,
  fileControllerCreateFile,
  fileControllerReplaceFile,
} from "../lib/gen-api";

export function useUploadFileAction(groupUuid: string | null): {
  uploadFile: (params: {
    file: File;
    folderUuid: string;
    fileUuid?: string;
    kitUuid?: string;
  }) => Promise<FileDto | undefined>;
};

export function useUploadFileAction(
  groupUuid: string | null,
  kitUuid: string | null,
): {
  uploadFile: (params: {
    file: File;
    folderUuid: string;
    fileUuid?: string;
  }) => Promise<FileDto | undefined>;
};

export function useUploadFileAction(
  groupUuid: string | null,
  kitUuid?: string | null,
) {
  const isLocal = window.location.host === "local-dev.99ravens.ai";

  return {
    uploadFile: async ({
      file,
      folderUuid,
      fileUuid,
      kitUuid: paramsKitUuid,
    }: {
      file: File;
      folderUuid: string;
      fileUuid?: string;
      kitUuid?: string;
    }) => {
      const contextKitUuid = kitUuid || paramsKitUuid;
      if (!groupUuid || !contextKitUuid) {
        throw new Error("Group UUID and Kit UUID are required");
      }

      const createResponse = !fileUuid
        ? await fileControllerCreateFile({
            body: {
              name: file.name,
              isKnowledge: true,
              isLibrary: false,
              groupUuid: groupUuid!,
              kitUuid: contextKitUuid,
              folderUuid,
            },
          })
        : await fileControllerReplaceFile({
            path: {
              fileUuid,
            },
          });

      const fileRecord = createResponse.data;
      if (!fileRecord) {
        throw new Error("Failed to create file record");
      }

      const contentType = contentTypeForUploadName(fileRecord.name);
      if (!contentType) {
        throw new Error("Invalid or unsupported file name.");
      }

      const uploadResponse = await fetch(fileRecord.signedUrl, {
        method: isLocal ? "POST" : "PUT", // Fake GCS uses POST
        body: file,
        headers: {
          "Content-Type": contentType,
          ...(isLocal
            ? {}
            : { "x-goog-content-length-range": `0,${MAX_FILESIZE}` }),
        },
      });

      if (!uploadResponse.ok) {
        throw new Error(`Failed to upload file: ${uploadResponse.statusText}`);
      }

      const confirmResponse = await fileControllerConfirmFileUpload({
        path: {
          fileUuid: fileRecord.uuid,
        },
      });

      return confirmResponse.data;
    },
  };
}
